import React, { useEffect, useState } from "react";
import CreateAppointment from "../components/modals/CreateAppointment";
import ThemeAddButton from "../components/ThemeComponent/ThemeAddButton";
import Table from "../components/ThemeComponent/ThemeDataTable";
import ThemeModal from "../components/ThemeComponent/ThemeModal";
import ThemePagination from "../components/ThemeComponent/ThemePagination";
import ThemeSearchInput from "../components/ThemeComponent/ThemeSearchInput";
import { PageHeading } from "../components/ThemeComponent/ThemeText";
import { formatDate, success } from "../utils/helpers.js";
import MonthlyCalendar from "../components/ThemeComponent/ThemeAppointmentCalender";
import {
  useDeleteappointmentMutation,
  useGetappointmentsbyCalenderQuery,
  useGetappointmentsQuery,
} from "../Redux/services/ClientAPis/appointmentApi";
import RemoveModal from "../components/modals/RemoveModal";
const AppointmentManagement = () => {
  const [loading, setLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [viewlist, setViewList] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null);
  const [start_date, setStartDate] = useState(null);
  const [end_date, setEndDate] = useState(null);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetappointmentsQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: page,
      },
      { refetchOnMountOrArgChange: true }
    );
  const {
    data: calenderData,
    isLoading: calenderLoading,
    refetch: calenderRefetch,
  } = useGetappointmentsbyCalenderQuery(
    {
      start_date: start_date ? start_date : "2025-01-21",
      end_date: end_date ? end_date : "2025-01-24",
    },
    { refetchOnMountOrArgChange: true }
  );

  const [deletetask, { isLoading: deleteLoading }] =
    useDeleteappointmentMutation();

  const header = [
    {
      title: "Date of Birth",
      dataIndex: "dob",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{formatDate(rowData?.patient?.dob)}</div>;
      },
    },

    {
      title: "Patient Name",
      dataIndex: "name",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.patient?.name}</div>;
      },
    },
    {
      title: "Insurance Provider",
      dataIndex: "insurance_provider",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.patient?.insurance_provider}</div>;
      },
    },
    {
      title: "Member Number",
      dataIndex: "member_number",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.patient?.member_number}</div>;
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.patient?.email}</div>;
      },
    },
    {
      title: "Phone",
      dataIndex: "mobile_no",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.patient?.mobile_no}</div>;
      },
    },
    {
      title: "Appointment Date",
      dataIndex: "appointment_date_at",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{formatDate(rowData?.appointment_date_at)}</div>;
      },
    },
  ];

  // const data = [
  //   {
  //     slug: 1,
  //     client_name: "Cameron Williamson",
  //     phone: "(603) 555-0123",
  //     email: "nathan.roberts@example.com",
  //     designation: "Physician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 2,
  //     client_name: "Floyd Miles",
  //     phone: "(209) 555-0104",
  //     email: "debbie.baker@example.com",
  //     designation: "Surgeon",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 3,
  //     client_name: "Annette Black",
  //     phone: "(704) 555-0127",
  //     email: "debbie.lawson@example.com",
  //     designation: "Radiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 4,
  //     client_name: "Theresa Webb",
  //     phone: "(808) 555-0111",
  //     email: "novah.simmons@example.com",
  //     designation: "Neurologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 5,
  //     client_name: "Kathryn Murphy",
  //     phone: "(307) 555-0133",
  //     email: "jessica.hanson@example.com",
  //     designation: "Physiotherapist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 6,
  //     client_name: "Brooklyn Simmons",
  //     phone: "(702) 555-0122",
  //     email: "felicia.reid@example.com",
  //     designation: "Pediatrician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 7,
  //     client_name: "Robert Fox",
  //     phone: "(252) 555-0125",
  //     email: "tim.jennings@example.com",
  //     designation: "Gynecologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 8,
  //     client_name: "Dianne Russell",
  //     phone: "(201) 555-0124",
  //     email: "curtis.weaver@example.com",
  //     designation: "Anesthesiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 9,
  //     client_name: "Leslie Alexander",
  //     phone: "(319) 555-0115",
  //     email: "michelle.rivera@example.com",
  //     designation: "Pathologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 10,
  //     client_name: "Devon Lane",
  //     phone: "(207) 555-0119",
  //     email: "dolores.chambers@example.com",
  //     designation: "Oncologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  // ];

  const handleDownloadCLick = () => {
    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
      success("Successfully Downloaded");
    }, 1500);
  };

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setPage(data.links.current);
      setTotalRecords(data.links.total_records === 0 ? '' : data.links.total_records);
      setTotalPages(data.links.total);
      // setRowData(data.data);
    }
  }, [data]);

  const onRemoveClick = async () => {
    await deletetask({ id: modalData.id });
    setTimeout(() => {
      setRemoveOpen(false);
      success("Successfully Removed");
      refetch();
    }, 500);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, [page]);

  return (
    <div className="dashboard-page patient-page">
      <div className="header d-flex justify-content-between">
        <PageHeading text={"All Appointments"} count={totalRecords} />
        <div className="d-flex responsive-flex align-items-center gap-3">
          <ThemeAddButton
            text={"Create Appointment"}
            onClick={() => setAddOpen(true)}
            className={"responsive-margin"}
          />
          <div
            className="view-list flex-custom-center cursor px-1"
            onClick={() => setViewList(!viewlist)}
          >
            {viewlist ? "View List" : "View Calender"}
          </div>
          <ThemeSearchInput setSearchQuery={setSearchQuery} />
        </div>
      </div>
      {!viewlist ? (
        <section>
          <div className="table-content mt-2">
            <Table
              header={header}
              data={data?.data}
              loading={isLoading}
              removeText="Appointment"
              onEditClick={() => setShowEdit(true)}
              setModalData={setModalData}
              setRemoveOpen={() => setRemoveOpen(true)}
            />
          </div>
          <div className="pagination mt-3">
            {/* {!loading && ( */}
              <ThemePagination
                activePage={page}
                totalPages={totalPages}
                setPage={setPage}
                page={page}
              />
            {/* )} */}
          </div>
        </section>
      ) : (
        <MonthlyCalendar
          data={calenderData?.data}
          isloading={calenderLoading}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      )}

      {addOpen && (
        <ThemeModal
          size={"xl"}
          modalContent={
            <CreateAppointment setIsOpen={setAddOpen} refetch={refetch} />
          }
          title={"Create Appointment"}
          className={"edit-profile"}
          isOpen={addOpen}
          setIsOpen={setAddOpen}
        />
      )}
      {showEdit && (
        <ThemeModal
          size={"xl"}
          modalContent={
            <CreateAppointment
              setIsOpen={setShowEdit}
              modalData={modalData}
              refetch={refetch}
            />
          }
          title={"Update Task"}
          className={"edit-profile"}
          isOpen={showEdit}
          setIsOpen={setShowEdit}
        />
      )}
      {removeOpen && (
        <ThemeModal
          size={"sm"}
          modalContent={
            <RemoveModal
              setIsOpen={setRemoveOpen}
              modalData={modalData}
              refetch={refetch}
              onRemoveClick={onRemoveClick}
              isLoading={deleteLoading}
            />
          }
          title={""}
          className={"edit-profile"}
          isOpen={removeOpen}
          setIsOpen={setRemoveOpen}
        />
      )}
    </div>
  );
};

export default AppointmentManagement;
